import { useEffect } from 'react';

/**
 * 2026-05-31 重做:之前是一个 React 跟随的 div(青色光斑 + 光晕 + 呼吸动画),
 * 用户反馈"很晕"。改用系统级 SVG 手形光标(cursor: url),效果在 global.css 里。
 *
 * 这个组件现在只负责一件事:在桌面 + 鼠标设备上,给 body 加 `tractor-cursor-enabled`
 * class,让 CSS 里的手形光标规则生效。手机/触屏不加,用系统默认。
 */
export function TractorCursor() {
  useEffect(() => {
    const finePointer = window.matchMedia('(pointer: fine) and (min-width: 768px)');

    function syncEnabled() {
      document.body.classList.toggle('tractor-cursor-enabled', finePointer.matches);
    }

    syncEnabled();
    finePointer.addEventListener('change', syncEnabled);

    return () => {
      finePointer.removeEventListener('change', syncEnabled);
      document.body.classList.remove('tractor-cursor-enabled');
    };
  }, []);

  return null;
}
